module.exports = __webpack_public_path__ + "img/product_31.99ff96d.svg";